import { takeLeading, put } from 'redux-saga/effects';
import { CHANGE_PARAM_LANGUAGE } from '@corefront/redux-aba';
import { serviceReload } from '../../actions/service';

export function* changeLanguageWorker() {
  yield put(serviceReload());
}

export function* changeLanguageWatcher() {
  yield takeLeading(CHANGE_PARAM_LANGUAGE, changeLanguageWorker);
}
